<template>
  <div>
    <fixed-header title="我的发票抬头"></fixed-header>
    <div class="invoice-title scroll-touch">
      <div class="invoice-title__main">
        <section v-for="(item, index) in titleList" :key="index" class="invoice-title__item">
          <div class="invoice-title__item-info">
            <div class="invoice-title__item-info__base"
                 @click="from === 'issue' ? chooseTitle(item) : ''">
              <span class="invoice-title__item-info__base__company">{{ item.invoiceTitle }}</span>
              <span class="invoice-title__item-info__base__tax_no">{{ item.taxpayer }}</span>
            </div>
            <div class="invoice-title__item-info__button" @click="gotoTitleEdit(item.id)">
              <span v-if="item.defaultState === 1" class="invoice-title__item-info__tag">默认</span>
              <i :class="['icon', 'invoice_arrow_trans']"></i>
            </div>
          </div>
        </section>
      </div>
      <div class="invoice-title__add" @click="gotoTitleEdit()">
        <div class="invoice-title__add-item">
          <i :class="['icon', 'invoice_title_add', 'icon_pos']"></i>
          <span>添加发票抬头</span>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import * as invoiceApis from 'apis/invoice';

import FixedHeader from 'components/common/FixedHeader';

export default {
  components: { FixedHeader },
  name: 'index',
  data() {
    const {
      query: { from },
    } = this.$route;

    return {
      from: from || '',
      titleList: [],
    };
  },
  mounted() {
    this.getTitleList();
  },
  methods: {
    async getTitleList() {
      try {
        const data = await invoiceApis.titleList();
        if (data) {
          this.titleList = data;
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`获取发票抬头列表失败:${message}`);
      }
    },
    gotoTitleEdit(id) {
      MgStat.send('click', {}, {
        mod: 'add_invoice_title',
        cont: '点击添加发票抬头',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceTitle',
      });
      this.$router.push({ path: '/invoice/title/edit', query: { id } });
    },
    chooseTitle(item) {
      sessionStorage.setItem('invoiceUserDefaultTitle', JSON.stringify(item));
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.invoice-title {
  height: 100%;

  &__main {
    box-sizing: border-box;
    height: 100%;
    position: relative;
    margin-top: 20px;
    background: #ffffff;
    border-top: 1px solid rgba(211, 211, 211, 0.5);
  }

  &__item {
    height: 130px;

    &-info {
      padding: 24px 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(211, 211, 211, 0.5);

      &__tag {
        font-size: 24px;
        color: #FF5F00;
        width: 70px;
        height: 34px;
        border-radius: 6px;
        text-align: center;
        border: 1px solid rgba(255, 95, 0, 1);
        margin-bottom: 40px;
        margin-right: 48px;
      }

      &__base {
        span {
          display: block;
          word-break: break-all;
          overflow: hidden;
          width: 536px;
        }

        &__company {
          font-size: 30px;
          height: 42px;
          color: #323232;
        }

        &__tax_no {
          margin-top: 5px;
          font-size: 26px;
          height: 37px;
          color: #BABABA;
        }
      }

      &__button {
        display: flex;
        align-items: center;

      }

    }
  }

  &__add {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    position: relative;
    margin: 20px 0;
    background: #ffffff;
    border-top: 1px solid rgba(211, 211, 211, 0.5);

    &-item {
      justify-content: center;
      position: absolute;
      display: flex;
      align-items: center;
      flex-direction: row;

      span {
        flex: 1;
        display: block;
        font-size: 30px;
        color: rgba(255, 95, 0, 1);
      }
    }


  }

}

</style>
